function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHammer = function SvgHammer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m9.218 8.67-5.723 5.723a.89.89 0 0 1-1.258 0l-.63-.63a.89.89 0 0 1 0-1.258L7.33 6.78"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.143 1.564 5.757 3.949a.89.89 0 0 0 0 1.259l5.034 5.034a.89.89 0 0 0 1.26 0l2.385-2.385a.89.89 0 0 0 0-1.259L9.4 1.564a.89.89 0 0 0-1.258 0"
  }));
};
export default SvgHammer;